import { useState } from 'react'
import Viewer360 from './components/Viewer360'

export default function App() {
  const [selectedModel, setSelectedModel] = useState('/models/coke_vending_machine.glb')
  const [availableMeshes, setAvailableMeshes] = useState([])
  const [selectedMesh, setSelectedMesh] = useState("")

  const models = [
    { name: "Model 1", file: "/models/coke_vending_machine.glb" },
    { name: "Model 2", file: "/models/coinmodel.glb" },
    { name: "Model 3", file: "/models/porchemodel.glb" },
    { name: "Model 4", file: "/models/vending_machine2.glb" },
    { name: "Model 5", file: "/models/dino_1.glb" }
  ]

  return (
    <>
      <Viewer360
        modelUrl={selectedModel}
        selectedMeshName={selectedMesh}
        onMeshesLoaded={(meshes) => {
              setAvailableMeshes(meshes)

              setSelectedMesh(prev => {
                // If current selection still exists in new model, keep it
                if (prev && meshes.includes(prev)) {
                  return prev
                }

                // Otherwise default to first mesh
                return meshes[0] || ""
              })
        }}

      />

      {/* Top Navigation Bar */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '80px',
        background: 'rgba(255,255,255,0.95)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 30px',
        zIndex: 20,
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
      }}>

        {/* Company Logo */}
        <img
          src="/branding/company_logo.png"
          alt="Company Logo"
          style={{ height: '50px' }}
        />

        {/* Model Buttons */}
        <div style={{ display: 'flex', gap: '15px' }}>
          {models.map(model => (
            <button
              key={model.file}
              onClick={() => setSelectedModel(model.file)}
              style={{
                padding: '8px 16px',
                borderRadius: '6px',
                border: '1px solid #ccc',
                background: selectedModel === model.file ? '#000' : '#fff',
                color: selectedModel === model.file ? '#fff' : '#000',
                cursor: 'pointer',
                fontWeight: 500
              }}
            >
              {model.name}
            </button>
          ))}
        </div>

        {/* Mesh Dropdown */}
        <select
          value={selectedMesh}
          onChange={(e) => setSelectedMesh(e.target.value)}
          style={{
            padding: '8px',
            borderRadius: '6px',
            border: '1px solid #ccc'
          }}
        >
          {availableMeshes.map((mesh, index) => (
            <option key={index} value={mesh}>
              {mesh}
            </option>
          ))}
        </select>
      </div>
    </>
  )
}



